// Arkus footer: the five link columns + contact block of the old arkusinc.com
// root footer portlet (static text portlet "footer-portlets"), plus the copyright line.
import React from 'react';
import { Container } from '@plone/components';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import CookieSettingsLink from './CookieSettingsLink';

export const FOOTER_COLUMNS = [
  {
    title: 'Arkus',
    href: '/',
    links: [
      ['About', '/about'],
      ['Certifications', '/about#some-of-our-certifications'],
      ['Executive Team', '/about#who-are-we'],
      ['Giving Back', '/about#how-do-we-give-back'],
      ['Celebrate', '/celebrate'],
    ],
  },
  {
    title: 'Clients',
    href: '/about',
    links: [
      ['Financial', '/about#financial-institutions'],
      ['Nonprofit', '/about#nonprofit-organizations'],
      ['Educational', '/about#educational-organizations'],
      ['Commercial', '/about#commercial-business-clients'],
    ],
  },
  {
    title: 'Resources',
    links: [
      [
        'Free Apps',
        'https://appexchange.salesforce.com/appxSearchKeywordResults?keywords=arkus%20inc',
      ],
      ['Arkus Blog', '/blog'],
      ['Podcast', '/cloudfocus-weekly'],
    ],
  },
  {
    title: 'Social',
    links: [
      ['Twitter', 'https://twitter.com/ArkusInc'],
      ['LinkedIn', 'https://www.linkedin.com/company/arkusinc/'],
      ['YouTube', 'https://www.youtube.com/channel/UC26GrDHbJ9uWtnrxBBO19Hg'],
    ],
  },
  {
    title: 'Connect',
    links: [
      ['Careers at Arkus', '/careers'],
      [
        'AppExchange',
        'https://appexchange.salesforce.com/appxListingDetail?listingId=a0N300000025s4UEAQ',
      ],
      ['Newsletter', '/subscribe'],
    ],
  },
];

const isExternal = (href) => /^https?:\/\//.test(href);

// Simple monochrome brand glyphs (24x24 viewBox), coloured by CSS (currentColor).
const ICONS = {
  Twitter: 'M18.9 2H22l-6.8 7.8L23.2 22h-6.3l-4.9-6.4L6.4 22H3.3l7.3-8.3L2.8 2h6.4l4.4 5.9L18.9 2Zm-1.1 18h1.7L8.3 3.9H6.5L17.8 20Z',
  LinkedIn: 'M4.98 3.5a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3 9.5h4V21H3V9.5Zm6.5 0h3.8v1.6h.1c.5-1 1.8-2 3.8-2 4 0 4.8 2.6 4.8 6V21h-4v-5.3c0-1.3 0-2.9-1.8-2.9s-2.1 1.4-2.1 2.8V21h-4V9.5Z',
  YouTube: 'M23 7.2a3 3 0 0 0-2.1-2.1C19 4.6 12 4.6 12 4.6s-7 0-8.9.5A3 3 0 0 0 1 7.2 31 31 0 0 0 .5 12a31 31 0 0 0 .5 4.8 3 3 0 0 0 2.1 2.1c1.9.5 8.9.5 8.9.5s7 0 8.9-.5a3 3 0 0 0 2.1-2.1 31 31 0 0 0 .5-4.8 31 31 0 0 0-.5-4.8ZM9.8 15.1V8.9l5.4 3.1-5.4 3.1Z',
};
const Icon = ({ name }) =>
  ICONS[name] ? (
    <svg className="arkus-footer-icon" viewBox="0 0 24 24" width="20" height="20" aria-hidden="true" focusable="false">
      <path fill="currentColor" d={ICONS[name]} />
    </svg>
  ) : null;

const FooterLink = ({ href, children }) =>
  isExternal(href) ? (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  ) : (
    <UniversalLink href={href}>{children}</UniversalLink>
  );

export const ArkusFooter = () => (
  <Container className="main-footer arkus-footer">
    <Container className="layout">
      <div className="arkus-footer-grid">
        {FOOTER_COLUMNS.map((col) => (
          <nav className="arkus-footer-col" key={col.title} aria-label={col.title}>
            <h2 className="arkus-footer-heading">
              {col.href ? (
                <FooterLink href={col.href}>{col.title}</FooterLink>
              ) : (
                col.title
              )}
            </h2>
            <ul>
              {col.links.map(([title, href]) => (
                <li key={title}>
                  <FooterLink href={href}>
                    {col.title === 'Social' && <Icon name={title} />}
                    {title}
                  </FooterLink>
                </li>
              ))}
            </ul>
          </nav>
        ))}
        <address className="arkus-footer-col arkus-footer-contact">
          <h2 className="arkus-footer-heading">
            <UniversalLink href="/contact">Contact</UniversalLink>
          </h2>
          <ul>
            <li>
              <UniversalLink href="/contact">Contact Arkus</UniversalLink>
            </li>
            <li className="addr">10 Times Square, 6th Floor</li>
            <li className="addr">New York, NY 10018</li>
          </ul>
        </address>
      </div>
    </Container>
  </Container>
);

export const ArkusCopyright = () => (
  <Container className="layout arkus-copyright">
    <p>
      Copyright <abbr title="Copyright">©</abbr> 2010-{new Date().getFullYear()}{' '}
      by Arkus, Inc. All rights reserved.{' '}
      <CookieSettingsLink />
    </p>
  </Container>
);

export default ArkusFooter;
